export default "<div class=\"not-found\">\n  <h3 class=\"not-found__text\">{{ isSearch ? textSearch : textEmpty }}</h3>\n</div>\n"